import type { FlashcardElementInput } from '../../flashcard/elements/registry'

export type PrimaryCheckboxRef = {
  face: 'front' | 'back'
  elementIndex: number
  layer: number
} | null

const getLayer = (el: FlashcardElementInput) =>
  typeof (el as Record<string, unknown>).layer === 'number'
    ? ((el as Record<string, unknown>).layer as number)
    : 0

export function resolvePrimaryCheckbox(
  front: FlashcardElementInput[],
  back: FlashcardElementInput[],
): PrimaryCheckboxRef {
  let best: PrimaryCheckboxRef = null

  const scan = (face: 'front' | 'back', elements: FlashcardElementInput[]) => {
    elements.forEach((el, index) => {
      if (!el || typeof el !== 'object') return
      if (el.type !== 'checkbox-group') return
      const layer = getLayer(el)

      if (!best) {
        best = { face, elementIndex: index, layer }
        return
      }

      if (layer > best.layer) {
        best = { face, elementIndex: index, layer }
      }
    })
  }

  scan('front', Array.isArray(front) ? front : [])
  scan('back', Array.isArray(back) ? back : [])

  return best
}

export function hasAnyCheckbox(front: FlashcardElementInput[], back: FlashcardElementInput[]) {
  return Boolean(resolvePrimaryCheckbox(front, back))
}
